<template>
    <div class="home h-100">
        <Navbar />

<!--        <template v-for="block in stateData.blocks">-->
<!--            <SSLandingView v-if="block.type == 'ss_landing'" :block='block' />-->
<!--        </template>-->

        <section class="mt-3" style="min-height: 50vh">
            <BlockListViewer :blocks="blocks" />
        </section>
        <Footer />

    </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/_colors.scss";


.overlay {
    background-color: rgba(38, 50, 56, .5);
}

.block + .block {
    border-top: 1px solid #dee2e6;
}

.block:first-child,
.block:last-child {
    border-bottom: 1px solid #dee2e6;
}

#product img {
    max-height: 200px;
}

#product .product-description p {
    text-align: center;
    width: 75%;
}

@media (min-width: 992px) {
    .rewards-program-text {
        position: absolute;
    }
    .rewards-program-text p {
        width: 50%;
    }
}
</style>

<script>
import { mapState, mapGetters } from 'vuex'

import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'

import RawView from '@/components/blocks/RawView'
import SSLandingView from '@/components/blocks/SSLandingView'
import BlockListViewer from "@/components/blocks/BlockListViewer";


export default {
    name: 'home',
    data: () => ({
        blocks: [],
    }),
    computed: mapState({
        stateData: state => state.stateData.stateData,
        socialStudiesPublications () {
            var socialStudiesPublications = []
            _.forEach(this.stateData.publications, publication => {
                if (publication.topic == 'Social Studies') {
                    socialStudiesPublications.push(publication)
                }
            })
            socialStudiesPublications = _.sortBy(socialStudiesPublications, 'language');
            socialStudiesPublications = _.orderBy(socialStudiesPublications, 'grade')
            socialStudiesPublications = _.uniqBy(socialStudiesPublications, 'grade')
            return socialStudiesPublications
        },
        sciencePublications () {
            var sciencePublications = []
            _.forEach(this.stateData.publications, publication => {
                if (publication.topic == 'Science') {
                    sciencePublications.push(publication)
                }
            })
            sciencePublications = _.sortBy(sciencePublications, 'language');
            sciencePublications = _.orderBy(sciencePublications, 'grade')
            sciencePublications = _.uniqBy(sciencePublications, 'grade')
            return sciencePublications
        },
        ...mapGetters({ isHomeschoolStore: 'isHomeschoolStore'}),
    }),
    components: {
        BlockListViewer,
        Navbar,
        Footer,
        RawView,
        SSLandingView
    },
    created () {
        this.getBlocks('4');
    },
    methods: {
        setHomeschoolStore(val) {
            this.$store.commit("setAsHomeschoolStore", val);
        },
        getBlocks(id) {
            this.$store.dispatch('getPageBlocks', {pageId: id, state: this.selectedState}).then((data) => {
                this.blocks = data;
            })
        }
    }
}
</script>
